<template lang="pug">
  main
    NavBar
    Loader(v-show="isLoading")
    section.section(v-show="!isLoading")
      .container
        .columns.has-text-centered
          .column.is-12
            h3.title.is-3 Firmar Responsiva&nbsp
              a.button.is-black.is-rounded(@click="backPage")
                i.fas.fa-times
        .columns
          .column.is-8
            bulma-accordion
              bulma-accordion-item
                p.title.is-5.has-text-weight-normal(slot='title')
                  | Artículos en: {{ responsiva_firma.nombre_responsiva }}
                i.material-icons(slot='icon') more_vert
                .high(slot='content')
                  .columns
                    .column.is-6
                      b Resg.:&nbsp
                      span {{ responsiva_firma.usuario }}
                      br
                      b Ubicación:&nbsp
                      span {{ responsiva_firma.ubicacion === 'ALL' ? 'Corporativo' : responsiva_firma.ubicacion }}
                    .column.is-6
                      b Fecha de Reg.:&nbsp
                      span {{ responsiva_firma.fechaReg }}
                  .columns.is-multiline.card-row(v-show='responsiva_firma.categoria==0')
                    .column.is-6(v-for="(i, index) in items" )
                      span.tag
                        | {{ i.descripcion }}
                      br
                      span.tag.is-black(v-show="i.serie !== ''")
                        | Serie: {{ i.serie }}
                  .columns.is-multiline.card-row(v-show='responsiva_firma.categoria >= 1')
                    .column.is-12
                      CardItems(:item='item')
          .column.is-12-mobile.is-4-tablet.is-4(v-show="!verSignature")
            .columns
              .column.is-offset-2.is-10
                figure.image.is-128x128.has-image-centered
                  img(:src="getImageFirma(responsiva)")
            .columns
              .column.is-offset-2.is-10
                a.button.is-black.is-rounded(@click="updateFirma")
                  | Volver a Firmar
          .column.is-12-mobile.is-4-tablet.is-4(v-show="verSignature")
            Signature(:limpiarSignature="limpiarSignature" @saveFile="checkFile" @sigWebStatus="sigWebStatus")
        .columns.column-blanco
</template>

<script>
  import Loader from '../shared/Loader.vue'
  import NavBar from './shared/NavBar.vue'
  import DataRespItems_Combustible from './components/DataRespItems_Combustible.vue'
  import DataRespItems_Computo from './components/DataRespItems_Computo.vue'
  import DataRespItems_Comunicacion from './components/DataRespItems_Comunicacion.vue'
  import DataRespItems_Peaje from './components/DataRespItems_Peaje.vue'
  import DataRespItems_Vehiculo from './components/DataRespItems_Vehiculo.vue'
  import CardItems from './components/CardItems.vue'

  import Signature from './components/Signature.vue'
  import ResponsivasService from '@/services/inventario/responsivas'
  import { BulmaAccordion, BulmaAccordionItem } from 'vue-bulma-accordion'

  import { mapState } from 'vuex'
import moment from 'moment'

  export default {
    name: 'FirmaResponsiva',
    components: { NavBar, Loader, Signature, DataRespItems_Combustible, DataRespItems_Computo, DataRespItems_Comunicacion, DataRespItems_Peaje, DataRespItems_Vehiculo, BulmaAccordion, BulmaAccordionItem, CardItems },
    data() {
      return {
        w: 320,
        h: 220,
        responsiva: {},
        isLoading: true,
        responsiva_array: [],
        ruta: '',
        firma: '',
        nombreFile: '',
        item: {},
        items: [],
        esFirmado: false,
        verSignature: false,
        limpiarSignature: false
      }
    },
    methods: {
      iniciarComponente () {
        
        if (this.responsiva.firma === 'E') {
          this.nombreFile = `firma_gerente_${this.responsiva.id}`
        } else {
          this.nombreFile = `firma_recibe_${this.responsiva.id}`
        }

        setTimeout(() => {
          this.obtenerItem()
          this.isLoading = false
        }, 340)
      },
      onLoad (event) {
        console.log(event)
      },
      onDocumentLoad (event) {
        console.log(event)
      },
      checkFile (file) {
        console.log(file)
        this.firma = file
        
        if (this.firma !== 'NoData') {

          if (this.esFirmado) {
            const fechaReg = moment().format('YYYY-MM-DD HH:mm:ss')
            ResponsivasService.update_Firma(this.responsiva.id, this.firma, this.nombreFile, this.responsiva.estado, this.responsiva.firma, fechaReg)
              .then( data => {
                const tema = data.success ? 'toasted-primary' : 'bubble'
                const icon = data.success ? 'done' : 'ban'
                this.displayToast(tema, data.respuesta, icon, 'OK')
                if (data.success) {
                  this.backPage()
                }
              })
              .catch( e => console.log(e))
          } else {
            const fechaReg = moment().format('YYYY-MM-DD HH:mm:ss')
            ResponsivasService.firmar(this.responsiva.id, this.firma, this.nombreFile, this.responsiva.estado, this.responsiva.firma, fechaReg)
              .then( data => {
                const tema = data.success ? 'toasted-primary' : 'bubble'
                const icon = data.success ? 'done' : 'ban'
                this.displayToast(tema, data.respuesta, icon, 'OK')
                if (data.success) {
                  this.backPage()
                }
              })
              .catch( e => {
                this.displayToast('bubble', `Error ${e.message}`, 'ban', 'OK')
                this.isLoading = false
              })
          }
        } else {
          console.log('No Guardar la Firma')
          this.displayToast('bubble', 'Error: No se ha firmado aún la responsiva.', 'ban', 'OK')
        }
      },
      backAccesos () {
        this.$router.push('/Responsivas')
      },
      obtenerItem() {
        switch (this.responsiva.categoria) {
          case 0:
            ResponsivasService.getItems_Multiples(this.responsiva.nombre_responsiva)
              .then( data => {
                console.log(data)
                this.items = data
              })
              .catch((e) => {
                this.isLoading = false
                console.log(e)
              })
            break
          case 1:
            ResponsivasService.getItems_Computo(this.responsiva.nombre_responsiva)
              .then( data => {
                console.log(data)
                this.item = this.convetirItemComputo(data[0])
              })
              .catch((e) => {
                this.isLoading = false
                console.log(e)
              })
            break
          case 2:
            ResponsivasService.getItems_Telefono(this.responsiva.nombre_responsiva)
              .then( data => {
                console.log(data)
                this.item = this.convetirItemsTelefono(data[0])
              })
              .catch((e) => {
                this.isLoading = false
                console.log(e)
              })
            break
          case 3:
            ResponsivasService.getItems_Combustible(this.responsiva.nombre_responsiva)
              .then( data => {
                console.log(data)
                this.item = data[0]
              })
              .catch((e) => {
                this.isLoading = false
                console.log(e)
              })
            break
          case 4:
            ResponsivasService.getItems_Peaje(this.responsiva.nombre_responsiva)
              .then( data => {
                console.log(data)
                this.item = this.convetirItemsPeaje(data[0])
              })
              .catch((e) => {
                this.isLoading = false
                console.log(e)
              })
            break
          case 5:
            ResponsivasService.getItems_Vehiculos(this.responsiva.nombre_responsiva)
              .then( data => {
                console.log(data)
                this.item = this.convetirItemsVehiculos(data[0])
              })
              .catch((e) => {
                this.isLoading = false
                console.log(e)
              })
            break
        
          default:
            break
        }
      },
      convetirItemComputo(item) {
        return {
          ...item,
          id: parseInt(item.id),
          accesorios: parseInt(item.accesorios),
          backpack: parseInt(item.backpack),
          caja: parseInt(item.caja),
          cargador: parseInt(item.cargador),
          funda: parseInt(item.funda),
          mouse: parseInt(item.mouse)
        }
      },
      convetirItemsTelefono(item) {
        return {
          ...item,
          adaptadorSd: parseInt(item.adaptadorSd),
          audifonos: parseInt(item.audifonos),
          caja: parseInt(item.caja),
          cargador: parseInt(item.cargador),
          id: parseInt(item.id),
          protector: parseInt(item.protector),
          sim: parseInt(item.sim),
        }
      },
      convetirItemsVehiculos(item) {
        return {
          ...item,
          anio_modelo: Number(item.anio_modelo),
          antena_radio: parseInt(item.antena_radio),
          batea: parseInt(item.batea),
          birlos: parseInt(item.birlos),
          bolsa_herr: parseInt(item.bolsa_herr),
          cables_corr: parseInt(item.cables_corr),
          control_ape: parseInt(item.control_ape),
          cristales: parseInt(item.cristales),
          emblema_del: parseInt(item.emblema_del),
          emblema_tras: parseInt(item.emblema_tras),
          encendedor: parseInt(item.encendedor),
          espejoLD: parseInt(item.espejoLD),
          espejoLI: parseInt(item.espejoLI),
          espejo_int: parseInt(item.espejo_int),
          extintor: parseInt(item.extintor),
          gato: parseInt(item.gato),
          id: parseInt(item.id),
          limpiadores: parseInt(item.limpiadores),
          llanta_refaccion: parseInt(item.llanta_refaccion),
          llave: parseInt(item.llave),
          llave_cruz: parseInt(item.llave_cruz),
          llave_tapComb: parseInt(item.llave_tapComb),
          manija_puerta: parseInt(item.manija_puerta),
          manual: parseInt(item.manual),
          placasF: parseInt(item.placasF),
          polizaV: parseInt(item.polizaV),
          porta_placaD: parseInt(item.porta_placaD),
          porta_placaT: parseInt(item.porta_placaT),
          radio_estereo: parseInt(item.radio_estereo),
          reflejantes: parseInt(item.reflejantes),
          tapetes: parseInt(item.tapetes),
          tapon_aceite: parseInt(item.tapon_aceite),
          tapon_gasolina: parseInt(item.tapon_gasolina),
          tapon_radiador: parseInt(item.tapon_radiador),
          tapon_rueda: parseInt(item.tapon_rueda),
          tarjeta_circ: parseInt(item.tarjeta_circ),
          varilla_aceite: parseInt(item.varilla_aceite),
          verificacion: parseInt(item.verificacion),
        }
      },
      convetirItemsPeaje(item) {
        return {
          ...item,
          estado: parseInt(item.estado)
        }
      },
      
      getImageFirma (responsiva) {
        let currentUrl = window.location.hostname
        let path = ''
        if (responsiva.firma === 'E') {
          path = `https://${currentUrl}${responsiva.firma_gerente}`
        } else {
          path = `https://${currentUrl}${responsiva.firma_user}`
        }
        return path
      },
      updateFirma () {
        this.verSignature = true
      },
      backPage () {
        this.$router.back()
      },

      sigWebStatus (val) {
        console.log(val)
        const tema = val ? 'toasted-primary' : 'bubble'
        const text = val ? 'sigWeb instalado' : 'No está instalado sigWeb'
        const icon = val ? 'done' : 'ban'
        this.displayToast(tema, text, icon, 'Ok' )
      },

      displayToast(tema, text, icon, actionText) {
        let toast = this.$toasted.show(text, { 
          theme: tema, 
          position: "bottom-right", 
          duration : 3000,
          iconPack: 'fontawesome',
          icon: icon,
          action : {
            text : actionText,
            onClick : (e, toastObject) => {
              toastObject.goAway(0)
            }
          },
        })
      }
    },
    created () {
      var currentUrl = window.location.hostname
      console.log(currentUrl)
      this.responsiva = this.responsiva_firma
      this.limpiarSignature = true
      if (this.responsiva.firma === 'E') {
        this.esFirmado = this.responsiva.firma_gerente !== '' ? true : false
      } else {
        this.esFirmado = this.responsiva.firma_user !== '' ? true : false
      }
      this.verSignature = this.esFirmado ? false : true
      this.responsiva_array.push(this.responsiva_firma)
      this.iniciarComponente()
    },
    computed: {
      ...mapState(['responsiva_firma', 'userLogin'])
    }
  }
</script>

<style lang="css" scoped>
  .column-blanco {
    padding-bottom: 100px;
  }
</style>


// WEBPACK FOOTER //
// src/components/responsivas_Componentes/FirmaResponsiva.vue